import React from "react";

import { ReportIndicator } from "@common/reportIndicator";
import { ReportIndicators } from "@planzone/dto";
import { Props } from "./types";
import styles from "./styles.scss";

function IndicatorsList({ indicators }: Props) {
  return (
    <div className={styles.indicatorsList}>
      {indicators
        .sort((firstIndicator, secondIndicator) =>
          firstIndicator.name < secondIndicator.name
            ? -1
            : firstIndicator.name > secondIndicator.name
              ? 1
              : 0,
        )
        .map((indicator) => (
          <div key={indicator.name} className={styles.input}>
            <ReportIndicator
              className={styles.indicator}
              value={indicator.value as ReportIndicators}
            />
            <p className={styles.name}>{indicator.name}</p>
          </div>
        ))}
      {indicators.length !== 5 &&
        new Array(5 - indicators.length)
          .fill("")
          .map((_, index) => <div key={index} className={styles.input} />)}
    </div>
  );
}

export { IndicatorsList };
